module.exports = __webpack_public_path__ + "img/mobile-app.9b273cb3.svg";